const isUserLogged = state => state.user.logged;

export const UserSelectors = {
  isUserLogged
}
